import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { WmProgressIndicator, WmProgressMonitor, WmProgressSlice } from "@watermarkinsights/ripple-react";
import "../../../common/Insights.scss";
import translate from "../../../../i18n/translate";
import { useIntl } from "react-intl";
import { popover } from "./CoursesChart";
import ApiError from "src/features/common/elements/ApiError";
export default function ProgramChart(_a) {
    var programData = _a.programData;
    return (_jsx(React.Fragment, { children: _jsxs("div", { children: [_jsx("h3", { className: "title organization-progress", children: translate("app.programProgressCard.programProgressDefinition") }), programData.programApiError ? (_jsx(ApiError, { containerClasses: "api-error" })) : (_jsxs(_Fragment, { children: [_jsx("p", { className: "org totals", children: translate("app.programProgressCard.totalPrograms", {
                                totalPrograms: programData.totalPrograms
                            }) }), _jsx("div", { id: "org-charts-html", children: _jsx(ProgramProgressChart, { programData: programData }) })] }))] }) }));
}
var ProgramProgressChart = function (_a) {
    var programData = _a.programData;
    var programsWithMission = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithMission"
    });
    var added = useIntl().formatMessage({
        id: "app.drilldown.added"
    });
    var notAdded = useIntl().formatMessage({
        id: "app.drilldown.notAdded"
    });
    var created = useIntl().formatMessage({
        id: "app.drilldown.created"
    });
    var notCreated = useIntl().formatMessage({
        id: "app.drilldown.notCreated"
    });
    var mapped = useIntl().formatMessage({
        id: "app.drilldown.mapped"
    });
    var notMapped = useIntl().formatMessage({
        id: "app.drilldown.notMapped"
    });
    var missionStatement = useIntl().formatMessage({
        id: "app.orgProgressCard.missionStatement"
    });
    var programsWithoutMission = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithoutMission"
    });
    var learningOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.learningOutcomes"
    });
    var successOutcomes = useIntl().formatMessage({
        id: "app.orgProgressCard.successOutcomes"
    });
    var ILOMapped = useIntl().formatMessage({
        id: "app.orgProgressCard.ILOMapped"
    });
    var curriculumMap = useIntl().formatMessage({
        id: "app.orgProgressCard.curriculumMap"
    });
    var programsWithLO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithLO"
    });
    var programsWithoutLO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithoutLO"
    });
    var programsWithSO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithSO"
    });
    var programsWithoutSO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithoutSO"
    });
    var programsWithCM = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithCM"
    });
    var programsWithoutCM = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithoutCM"
    });
    var programsWithILO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithILO"
    });
    var programsWithoutILO = useIntl().formatMessage({
        id: "app.programProgressCard.programsWithoutILO"
    });
    return (_jsx("div", { id: "prog-charts", children: _jsxs(WmProgressMonitor, { id: "program-progress", "print-mode": true, "bar-labels-width": "5rem", children: [_jsxs(WmProgressIndicator, { label: missionStatement, children: [_jsx(WmProgressSlice, { legend: added, amount: programData.programMissionComplete.toString(), popoverTitle: popover(programData.programMissionComplete, programData.totalPrograms), popoverText: programsWithMission }), _jsx(WmProgressSlice, { legend: notAdded, amount: programData.programMissionIncomplete.toString(), popoverTitle: popover(programData.programMissionIncomplete, programData.totalPrograms), popoverText: programsWithoutMission })] }), _jsxs(WmProgressIndicator, { label: learningOutcomes, children: [_jsx(WmProgressSlice, { legend: created, amount: programData.programLearningOutcomes.toString(), popoverTitle: popover(programData.programLearningOutcomes, programData.totalPrograms), popoverText: programsWithLO }), _jsx(WmProgressSlice, { legend: notCreated, popoverTitle: popover(programData.programLearningOutcomesIncomplete, programData.totalPrograms), popoverText: programsWithoutLO, amount: programData.programLearningOutcomesIncomplete.toString() })] }), _jsxs(WmProgressIndicator, { label: successOutcomes, children: [_jsx(WmProgressSlice, { legend: created, amount: programData.programSuccessOutcomes.toString(), popoverTitle: popover(programData.programSuccessOutcomes, programData.totalPrograms), popoverText: programsWithSO }), _jsx(WmProgressSlice, { legend: notCreated, amount: programData.programSuccessOutcomesIncomplete.toString(), popoverTitle: popover(programData.programSuccessOutcomesIncomplete, programData.totalPrograms), popoverText: programsWithoutSO })] }), _jsxs(WmProgressIndicator, { label: curriculumMap, children: [_jsx(WmProgressSlice, { legend: mapped, amount: programData.programCurriculumMapsComplete.toString(), popoverTitle: popover(programData.programCurriculumMapsComplete, programData.totalPrograms), popoverText: programsWithCM }), _jsx(WmProgressSlice, { legend: notMapped, amount: programData.programCurriculumMapsIncomplete.toString(), popoverTitle: popover(programData.programCurriculumMapsIncomplete, programData.totalPrograms), popoverText: programsWithoutCM })] }), _jsxs(WmProgressIndicator, { label: ILOMapped, children: [_jsx(WmProgressSlice, { legend: mapped, amount: programData.iloProgramMappingsComplete.toString(), popoverTitle: popover(programData.iloProgramMappingsComplete, programData.totalPrograms), popoverText: programsWithILO }), _jsx(WmProgressSlice, { legend: notMapped, amount: programData.iloProgramMappingsIncomplete.toString(), popoverTitle: popover(programData.iloProgramMappingsIncomplete, programData.totalPrograms), popoverText: programsWithoutILO })] })] }) }));
};
